import { render, staticRenderFns } from "./valueData.vue?vue&type=template&id=0895a1bf&scoped=true&"
import script from "./valueData.vue?vue&type=script&lang=js&"
export * from "./valueData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0895a1bf",
  null
  
)

export default component.exports